import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { useQuote } from "@/context/QuoteContext";
import { QUICK_SERVICES } from "@/constants/site";

const QuickSelector = () => {
  const { openQuote } = useQuote();

  return (
    <section className="bg-[#F8F9FA] py-20 sm:py-28" data-testid="quick-service-selector">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          eyebrow="Quick Dispatch"
          title="What's the situation?"
          sub="Pick your emergency — we'll pre-fill a text or WhatsApp message so dispatch gets your request in one tap."
        />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {QUICK_SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08}>
              <button
                onClick={() => openQuote(s)}
                data-testid={`service-card-${s.id}`}
                className="group relative flex h-full w-full flex-col items-start justify-between gap-8 border border-zinc-200 bg-white p-5 sm:p-7 text-left transition-all duration-300 hover:-translate-y-1.5 hover:border-emergency hover:shadow-[0_20px_50px_-20px_rgba(200,16,46,0.35)]"
              >
                <s.icon className="h-8 w-8 sm:h-10 sm:w-10 text-emergency transition-transform duration-300 group-hover:scale-110" strokeWidth={1.8} />
                <div>
                  <p className="font-display text-lg sm:text-2xl font-bold uppercase leading-tight text-zinc-900">
                    {s.label}
                  </p>
                  <p className="mt-2 flex items-center gap-1 font-mono text-[10px] sm:text-xs tracking-[0.15em] uppercase text-zinc-500 transition-colors group-hover:text-emergency">
                    Tap to dispatch <ArrowUpRight className="h-3.5 w-3.5" />
                  </p>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickSelector;
